var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onChange}}),_c('a-button',{attrs:{"shape":"round","loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("批量导入")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }